export default "__VITE_ASSET__BMu__v6G__"